export enum TrackingEvent {
    //
    // Page Views & Performance
    //
    PAGE_VIEWED = 'page_viewed',
    PAGE_LOAD_PERFORMANCE = 'page_load_performance',
    PAGE_LOAD_FAILED = 'page_load_failed',

    //
    // List Views
    //
    OBSERVATION_LIST_VIEWED = 'observation_list_viewed',
    TICKET_LIST_VIEWED = 'ticket_list_viewed',
    INVOICE_LIST_VIEWED = 'invoice_list_viewed',
    COMMUNICATIONS_LIST_VIEWED = 'communications_list_viewed',
    PRESET_VIEWED = 'preset_viewed',

    //
    // Navigation & Errors
    //
    PAGE_NAVIGATED = 'page_navigated',
    NAVIGATION_ERROR = 'navigation_error',

    //
    // Individual Actions
    //
    OBSERVATION_VIEWED = 'observation_viewed',
    TICKET_VIEWED = 'ticket_viewed',
    NOTE_ADDED = 'note_added',
    NOTE_EDITED = 'note_edited',
    NOTE_REMOVED = 'note_removed',
    OFFENDER_ADDED = 'offender_added',
    OFFENDER_EDITED = 'offender_edited',
    OWNER_ADDED = 'owner_added',
    OWNER_EDITED = 'owner_edited',
    SYNC_OFFENDER = 'sync_offender',
    STATUS_CHANGE = 'status_change',
    OBJECTION_ADDED = 'objection_added',
    OBJECTION_HANDLED = 'objection_handled',
    DECISION_ADDED = 'decision_added',
    DOCUMENT_CREATED = 'document_created',
    DOCUMENT_SENT = 'document_sent',
    DOCUMENT_MARKED_AS_SENT = 'document_marked_as_sent',
    MEDIATION_PROPOSED = 'mediation_proposed',
    OFFENSE_EDITED = 'offense_edited',
    VEHICLE_EDITED = 'vehicle_edited',
    IMAGE_ADDED = 'image_added',
    IMAGE_REMOVED = 'image_removed',
    PAYMENT_ADDED = 'payment_added',
    CCM_ADDED = 'ccm_added',
    CCM_EDITED = 'ccm_edited',

    //
    // Batch Actions
    //
    BATCH_ACTION_PERFORMED = 'batch_action_performed',
    BATCH_ACTION_FAILED = 'batch_action_failed',
    BATCH_ACTION_PERFORMANCE = 'batch_action_performance',

    //
    // Wizard Flows
    //
    WIZARD_STEP_COMPLETED = 'wizard_step_completed',
    WIZARD_ERROR = 'wizard_error',
}
